import * as XLSX from 'xlsx';

const PRODUCT_SHEET_NAME = 'Productos';

function readCell(row, keys) {
  for (const key of keys) {
    if (row[key] !== undefined && row[key] !== null) return String(row[key]).trim();
  }
  return '';
}

export function downloadProductBulkTemplate(categories = []) {
  const productRows = [
    ['SKU', 'Titulo', 'Precio', 'Descripcion', 'Categoria 1', 'Categoria 2', 'Categoria 3'],
    ['POLO-NEGRO-M', 'Polo Negro Talla M', '0', 'Polo negro de algodon talla M', '', '', ''],
    ['', 'Set de maquillaje basico', '0', 'Set de maquillaje sellado en caja', '', '', ''],
  ];

  const instructions = [
    ['INSTRUCCIONES - CARGA MASIVA DE PRODUCTOS'],
    [''],
    ['Campos obligatorios: Titulo y Descripcion.'],
    ['SKU es opcional. Si se deja vacio, Fast Max generara uno automaticamente.'],
    ['Precio es opcional. Si se deja vacio, se guardara como 0.'],
    ['Categorias son opcionales. Si deseas usarlas, copia el nombre desde la pestana Categorias.'],
    ['No incluyas imagenes en esta plantilla. Las imagenes se pueden subir despues desde el inventario.'],
  ];

  const categoryRows = [
    ['ID', 'Categoria'],
    ...categories.map((category) => [category.id, category.name]),
  ];

  const wsProducts = XLSX.utils.aoa_to_sheet(productRows);
  const wsInstructions = XLSX.utils.aoa_to_sheet(instructions);
  const wsCategories = XLSX.utils.aoa_to_sheet(categoryRows);

  wsProducts['!cols'] = [
    { wch: 22 },
    { wch: 34 },
    { wch: 12 },
    { wch: 55 },
    { wch: 24 },
    { wch: 24 },
    { wch: 24 },
  ];
  wsInstructions['!cols'] = [{ wch: 95 }];
  wsCategories['!cols'] = [{ wch: 10 }, { wch: 36 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, wsProducts, PRODUCT_SHEET_NAME);
  XLSX.utils.book_append_sheet(workbook, wsCategories, 'Categorias');
  XLSX.utils.book_append_sheet(workbook, wsInstructions, 'Instrucciones');

  XLSX.writeFile(workbook, 'Plantilla_Productos_FastMax.xlsx');
}

export async function parseProductBulkExcel(file, categories = []) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames.includes(PRODUCT_SHEET_NAME)
          ? PRODUCT_SHEET_NAME
          : workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { raw: false, defval: '' });

        const categoryByName = new Map(
          categories.map((category) => [String(category.name).trim().toLowerCase(), category])
        );

        const products = rows
          .map((row, index) => {
            const title = readCell(row, ['Titulo', 'Titulo *', 'Title']);
            const sku = readCell(row, ['SKU', 'Sku', 'sku']);
            const price = readCell(row, ['Precio', 'Price']);
            const description = readCell(row, ['Descripcion', 'Descripcion *', 'Description']);
            const categoryNames = [
              readCell(row, ['Categoria 1', 'Category 1']),
              readCell(row, ['Categoria 2', 'Category 2']),
              readCell(row, ['Categoria 3', 'Category 3']),
            ];
            const categoryIds = categoryNames.map((name) => {
              if (!name) return '';
              return categoryByName.get(name.toLowerCase())?.id || '';
            });

            return {
              id: `${Date.now()}-${index}`,
              rowNumber: index + 2,
              sku,
              title,
              price,
              description,
              categoryIds,
              originalCategoryNames: categoryNames,
            };
          })
          .filter((product) =>
            product.title ||
            product.sku ||
            product.price ||
            product.description ||
            product.originalCategoryNames.some(Boolean)
          );

        resolve(products);
      } catch (error) {
        reject(new Error(`Error al leer el Excel: ${error.message}`));
      }
    };

    reader.onerror = () => reject(new Error('Error al leer el archivo'));
    reader.readAsArrayBuffer(file);
  });
}
